/*@ngInject*/
const DataSetBrowserController = function ($rootScope, $scope, $filter, $uibModal, localization, advancedFilterType, filterType, dataSetType, configurationMediator, dataSetAction, configurationActionsUtil, databaseDownloadSectionName, modalUtil, gridDataBrowserConstant) {

    localization.getTranslationByKey('dataSetBrowser').then(function (translations) {

        $scope.columns = [{
            name: 'name',
            label: _.get(translations, 'columns.name'),
            className: 'colName',
            getValue: function (item) {
                return item.name;
            }
        }, {
            name: 'type',
            label: _.get(translations, 'columns.type'),
            className: 'colType',
            getValue: function (item) {
                return _.get(translations, 'type.' + item.type);
            }
        }, {
            name: 'description',
            label: _.get(translations, 'columns.description'),
            className: 'colDescription',
            getValue: function (item) {
                return item.description;
            }
        }, {
            name: 'lastModifiedBy',
            label: _.get(translations, 'columns.lastModifiedBy'),
            className: 'colLastModifiedBy',
            getValue: function (item) {
                return item.lastModifiedBy;
            }
        }, {
            name: 'timeLastModified',
            label: _.get(translations, 'columns.timeLastModified'),
            className: 'colTimeLastModified',
            getValue: function (item) {
                return $filter('date')(item.timeLastModified, 'MM/dd/yy hh:mma');
            }
        }];

        $scope.advancedFilterType = advancedFilterType.DATA_SET_BROWSER;
        $scope.filterType = filterType.TYPE_DATASET_FILTER;

        $scope.stateParams = {
            browser: 'configuration.dataSetBrowser',
            getDetailState: function (dataSet) {
                var stateName;

                if (dataSet.type === dataSetType.REPEATING_FORM) {
                    stateName = 'configuration.dataSetEditor.repeatingForm';
                } else {
                    stateName = 'configuration.dataSetEditor.dataItems';
                }

                return {
                    name: stateName,
                    params: {
                        dataSetName: dataSet.name,
                        type: dataSet.type
                    }
                };
            }
        };

        $scope.translations = {
            title: _.get(translations, 'title'),
            recordCountText: _.get(translations, 'recordCountText'),
            recordsCountText: _.get(translations, 'recordsCountText'),
            emptyGrid: _.get(translations, 'emptyGrid'),
            bulkActionLabel: _.get(translations, 'bulkActionLabel'),
            bulkActionCancelButtonLabel: _.get(translations, 'bulkActionCancelButtonLabel')
        };

        $scope.initialRequestParams = {
            key: 'name',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc'
        };

        $scope.loadActionsHandler = function () {
            return configurationMediator.loadDataSetBrowserActions().then(function (actions) {
                _.each(actions.actions, function (action) {
                    if (action.name === dataSetAction.EXPORT) {
                        action.isBulkAction = true;
                        action.bulkActionLabel = _.get(translations, 'export.bulkActionLabel');
                    }
                });

                actions.hiddenInputActions = {};

                return actions;
            });
        };

        $scope.loadItemsHandler = function (filterUri, requestParams) {
            return configurationMediator.getDataSetsByFilterUri(filterUri, requestParams).then(function (result) {
                _.each(result.records, function (dataSet) {
                    dataSet.id = dataSet.name;
                });

                return result;
            });
        };

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case dataSetAction.NEW_DATA_SET:
                        $uibModal.open({
                            templateUrl: '/configuration/dataSetSettings/dataSetSettingsTemplate.tpl.html',
                            controller: 'dataSetSettingsController',
                            windowClass: 'dataSetSettingsModal',
                            resolve: {
                                modalOptions: function() {
                                    return {
                                        existingDataSetName: null
                                    };
                                }
                            }
                        });
                        break;

                    case dataSetAction.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.DATA_SETS, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.handleBulkAction = function (action, selectedItems, excludedItems, filterUri) {
            if (action.enabled) {
                switch (action.name) {
                    case dataSetAction.EXPORT:
                        configurationActionsUtil.exportDataSets(selectedItems, filterUri, excludedItems).then(function () {
                            $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
                        });
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
                        break;
                }
            }
        };
    });
};

angular.module('ums.configuration')
    .controller('dataSetBrowserController', DataSetBrowserController);
